import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type SkeletonCardVariant = 'kpi' | 'chart' | 'list';

/** Card-content placeholder. Render it inside the real mat-card so the card chrome stays put. */
@Component({
    selector: 'ctv-skeleton-card',
    template: `
    <div class="dxk-skeleton-card" [class]="'dxk-skeleton-card--' + variant"
         role="status" aria-live="polite">
      <span class="dxk-visually-hidden">{{ label }}</span>
      @switch (variant) {
        @case ('kpi') {
          <ctv-skeleton width="40%"></ctv-skeleton>
          <ctv-skeleton height="28px" width="60%"></ctv-skeleton>
        }
        @case ('chart') {
          <ctv-skeleton width="35%"></ctv-skeleton>
          <ctv-skeleton shape="block"></ctv-skeleton>
        }
        @default {
          @for (l of lineList; track l) {
            <ctv-skeleton [width]="l % 3 === 2 ? '70%' : '100%'"></ctv-skeleton>
          }
        }
      }
    </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SkeletonCardComponent {
  @Input() public variant: SkeletonCardVariant = 'list';
  @Input() public lines = 4;
  @Input() public label = 'Loading';

  public get lineList(): number[] { return Array.from({ length: this.lines }, (_, i) => i); }
}
